import { IRow, MemoizedBasicTable, StringNumberArrayType } from 'components/Table/BasicTable';
import React, { useMemo } from 'react';
import { IOfferingCategoryResponse } from 'types/api/temple';

interface OfferingCategoryTableProps {
    editHandler?: ((id: string | number) => void | Promise<any>) & Function,
    deleteHandler?: ((id: string | number) => void | Promise<any>) & Function,
    deletingIds?: StringNumberArrayType,
    offeringCategories: IOfferingCategoryResponse[]
}

const getRows = (offeringCategories: IOfferingCategoryResponse[]) : IRow[] => {
    let rows : IRow[] = []
    offeringCategories.forEach(cat => {
        rows.push({
            id: cat.id,
            values: [cat.name, cat.offerings.length]
        })
    })
    return rows
}

const OfferingCategoryTable : React.FC<OfferingCategoryTableProps> = ({editHandler, deleteHandler, deletingIds, offeringCategories}) => {
    const rows = useMemo(() => getRows(offeringCategories),[offeringCategories])
    return (
        <MemoizedBasicTable
            rows={rows}
            headRow={['common.name', 'offering.no']}
            editHandler={editHandler}
            deleteHandler={deleteHandler}
            deletingIds={deletingIds}
        />
    );
};

export default OfferingCategoryTable;